<template>
  <div class="about-project__wrapper">
    <div class="about-project__container">
      <div class="about-project__line-wrapper">
        <div class="about-project__line-container">
          <div class="about-project__circle-1"></div>
          <div class="about-project__line-line"></div>
          <div class="about-project__circle-2"></div>
          <div class="about-project__line-line"></div>
          <div class="about-project__circle-3"></div>
          <div class="about-project__line-line"></div>
          <div class="about-project__circle-4"></div>
          <div class="about-project__line-line"></div>
          <div class="about-project__circle-5"></div>
        </div>
        <div class="about-project__line-text_container">
          <div class="about-project__line-text" v-html="line.first"></div>
          <div class="about-project__line-text" v-html="line.second"></div>
          <div class="about-project__line-text" v-html="line.third"></div>
          <div class="about-project__line-text" v-html="line.fourth"></div>
          <div class="about-project__line-text" v-html="line.fifth"></div>
        </div>
      </div>
      <div class="about-project__text-container">
        <div class="about-project__text-title">
          <span v-html="titleFirst" :style="styleTitleFirst"></span>
          <span v-html="titleSecond" :style="styleTitleSecond"></span>
          <img :src="titleImg" alt="" />
        </div>
        <div class="about-project__text-p" v-html="pFirst"></div>
        <div class="about-project__text-p" v-html="pSecond"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Observer } from "gsap/Observer";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(Observer);

export default {
  props: [
    "line",
    "titleFirst",
    "titleSecond",
    "styleTitleFirst",
    "styleTitleSecond",
    "pFirst",
    "pSecond",
    "titleImg",
  ],
  data() {
    return {
      tl: null,
    };
  },
  mounted() {


    this.tl = gsap.timeline();

    this.tl.to(".about-project__circle-1", {
      scrollTrigger: {
        trigger: ".about-project__wrapper",
        start: "0% 70%",
        end: "30% 90%",
        scrub: 1,
        // markers: true,
      },
      background: "#fff",
    });
    this.tl.to(".about-project__circle-2", {
      scrollTrigger: {
        trigger: ".about-project__wrapper",
        start: "0% 60%",
        end: "30% 80%",
        scrub: 1,
        // markers: true,
      },
      background: "#fff",
    });
    this.tl.to(".about-project__circle-3", {
      scrollTrigger: {
        trigger: ".about-project__wrapper",
        start: "0% 50%",
        end: "30% 70%",
        scrub: 1,
        // markers: true,
      },
      background: "#fff",
    });
    this.tl.to(".about-project__circle-4", {
      scrollTrigger: {
        trigger: ".about-project__wrapper",
        start: "0% 40%",
        end: "30% 60%",
        scrub: 1,
        // markers: true,
      },
      background: "#fff",
    });
    this.tl.to(".about-project__circle-5", {
      scrollTrigger: {
        trigger: ".about-project__wrapper",
        start: "0% 30%",
        end: "30% 50%",
        scrub: 1,
        // markers: true,
      },
      background: "#fff",
    });

  },
  beforeUnmount() {
    this.tl.kill();
    this.tl = null;
  },
};
</script>

<style lang="scss">
$maxWidth: 1920;
@mixin adaptivPadding(
  $pcSize1,
  $pcSize2,
  $pcSize3,
  $pcSize4,
  $mobSize1,
  $mobSize2,
  $mobSize3,
  $mobSize4
) {
  $addSize1: $pcSize1 - $mobSize1;
  $addSize2: $pcSize2 - $mobSize2;
  $addSize3: $pcSize3 - $mobSize3;
  $addSize4: $pcSize4 - $mobSize4;
  $maxWidth: $maxWidth - 320;
  padding-top: calc(
    #{$mobSize1 + px} + #{$addSize1} * ((100vw - 320px) / #{$maxWidth})
  );
  padding-right: calc(
    #{$mobSize2 + px} + #{$addSize2} * ((100vw - 320px) / #{$maxWidth})
  );
  padding-bottom: calc(
    #{$mobSize3 + px} + #{$addSize3} * ((100vw - 320px) / #{$maxWidth})
  );
  padding-left: calc(
    #{$mobSize4 + px} + #{$addSize4} * ((100vw - 320px) / #{$maxWidth})
  );

  @media (min-width: 1920px) {
    padding-top: $pcSize1 + px;
    padding-right: $pcSize2 + px;
    padding-bottom: $pcSize3 + px;
    padding-left: $pcSize4 + px;
  }
}
@mixin adaptiv-font($pcSize, $mobSize) {
  $addSize: $pcSize - $mobSize;
  $maxWidth: $maxWidth - 320;
  font-size: calc(
    #{$mobSize + px} + #{$addSize} * ((100vw - 320px) / #{$maxWidth})
  );

  @media (min-width: 1920px) {
    font-size: $pcSize + px;
  }
}

.about-project__wrapper {
  @include adaptivPadding(120, 0, 80, 0, 40, 0, 50, 0);

  background: #1d1d1d;
}
.about-project__container {
  display: grid;
  grid-template-columns: 1.5fr 2fr;

  max-width: 1500px;
  width: 100%;

  margin: 0 auto;
}
.about-project__line-wrapper {
  display: flex;
  column-gap: 17px;
}
.about-project__line-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.about-project__circle-1,
.about-project__circle-2,
.about-project__circle-3,
.about-project__circle-4,
.about-project__circle-5 {
  width: 16px;
  height: 16px;

  border-radius: 50%;
  border: 3px solid #fff;
  background: #262626;
}
.about-project__line-line {
  width: 4px;
  height: 70px;

  background-color: #fff;
}
.about-project__line-text_container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  height: 100%;
}
.about-project__line-text {
  color: #fff;
  font-family: "Helvetica-thin";
  @include adaptiv-font(17, 12);
  font-style: normal;
  font-weight: 300;
  line-height: 123%;
  letter-spacing: 0.564px;
}
.about-project__text-container {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}

.about-project__text-title {
  color: #fff;
  @include adaptiv-font(56, 25);
  font-style: normal;
  font-weight: 550;
  line-height: 100%;
  letter-spacing: 0.5px;
}
.about-project__text-p {
  color: #fff;
  font-family: "Helvetica-thin";
  @include adaptiv-font(21, 12);
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.2px;
}

@media (max-width: 1540px) {
  .about-project__container {
    width: 86%;
    margin: 0 auto;
  }
}
@media (max-width: 840px) {
  .about-project__container {
    grid-template-columns: 1fr;
    row-gap: 60px;
  }
  .about-project__text-container {
    row-gap: 22px;
  }
}
</style>
